'use es6';

import http from 'hub-http/clients/apiClient';
export default {
  checkGoodUsage: function checkGoodUsage(goodDestinationId) {
    return http.get("cosindex/api/v1/connections/" + goodDestinationId + "/parents", {
      query: {
        levels: 5
      }
    });
  },
  checkPackChildUsage: function checkPackChildUsage(packChildren) {
    return http.get('cosindex/api/v1/connections/parents', {
      query: {
        id: packChildren.toJS(),
        levels: 5
      }
    });
  }
};